import { ChevrondownSvg } from "@/src/Asset";
import { ReactNode, useRef } from "react";
import "swiper/css"; // Import Swiper styles

const NavbarSlider = ({
  slides,
  title = "",
  titleColor = "text-primary-text",
  buttonTextColor = "text-primary",
  buttonBorderColor = "border-primary",
  slidesMobile = 1,
  slidesTablet = 5,
  slidesDesktop = 10,
  slideClassName = "mr-2",
  showButton = true,
  showPagination = true,
}: {
  slides: Array<ReactNode>;
  title?: string;
  titleColor?: string;
  slidesMobile?: number;
  slidesTablet?: number;
  slidesDesktop?: number;
  slideClassName?: string;
  showButton?: boolean;
  showPagination?: boolean;
  buttonBorderColor?: string;
  buttonTextColor?: string;
}) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  const scrollLeft = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({
        left: -containerRef.current.clientWidth / slidesMobile,
        behavior: "smooth",
      });
    }
  };

  const scrollRight = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({
        left: containerRef.current.clientWidth / slidesMobile,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="relative flex flex-col md:gap-4 max-w-screen-xl w-full">
      <div className="flex justify-between">
        <div className={`text-[30px] font-semibold ${titleColor}`}>{title}</div>
      </div>

      <div className="relative flex items-center">
        {showButton && (
          <button
            className={`flex-shrink-0 md:mx-4 lg:mx-0 border ${buttonBorderColor} rounded-full size-6 lg:size-8 flex items-center justify-center ${buttonTextColor} z-10`}
            onClick={scrollLeft}
            aria-label="Scroll Left"
          >
            <ChevrondownSvg className="rotate-90" />
          </button>
        )}

        <div
          ref={containerRef}
          className={`flex gap-1 md:gap-2.5 overflow-x-auto md:overflow-hidden hide-scrollbar w-full ${slideClassName}`}
        >
          {slides?.map((slide, index) => (
            <div key={index} className="w-auto min-w-max px-1 md:px-2.5">
              {slide}
            </div>
          ))}
        </div>

        {showButton && (
          <button
            className={`flex-shrink-0  md:mx-4 border ${buttonBorderColor} size-6 lg:size-8 flex items-center justify-center rounded-full ${buttonTextColor} z-10`}
            onClick={scrollRight}
            aria-label="Scroll Right"
          >
            <ChevrondownSvg className="-rotate-90" />
          </button>
        )}
      </div>
    </div>
  );
};

export default NavbarSlider;
